import * as React from "react";
import { CancelAppointmentContext } from "./context.js";
const CancelAppointmentProvider = ({
  children,
  ...config
}) => {
  const [appointment, setAppointment] = React.useState(void 0);
  const [store, setStore] = React.useState(void 0);
  const values = React.useMemo(
    () => ({
      config,
      store,
      appointment,
      setAppointment,
      setStore
    }),
    [appointment, store, config, setStore, setAppointment]
  );
  return /* @__PURE__ */ React.createElement(CancelAppointmentContext.Provider, { value: values }, children);
};
export {
  CancelAppointmentProvider
};
//# sourceMappingURL=provider.js.map
